import { render, staticRenderFns } from "./LmDocumentMovements.vue?vue&type=template&id=5df6038a&scoped=true&"
import script from "./LmDocumentMovements.vue?vue&type=script&lang=js&"
export * from "./LmDocumentMovements.vue?vue&type=script&lang=js&"
import style0 from "./LmDocumentMovements.vue?vue&type=style&index=0&id=5df6038a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df6038a",
  null
  
)

export default component.exports